import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Membership = () => {
    return (
        <div className="membership-page py-5">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={10}>
                        <div className="text-center mb-5">
                            <h1 className="display-4 mb-3">MFS Membership</h1>
                            <div className="bg-primary" style={{ height: '4px', width: '100px', margin: '0 auto' }}></div>
                        </div>

                        <Card className="shadow-lg border-0">
                            <Card.Body className="p-5">
                                <div className="mb-4">
                                    <p className="lead mb-4">
                                        The Society's members are part of an international network of academics and professionals 
                                        involved in the research, teaching and practice of finance. They are encouraged to attend 
                                        the Society's annual conferences and special symposia, held in different international locations. 
                                        Members are entitled to reduced manuscript submission fees and have free e-access to the 
                                        Multinational Finance Journal, published quarterly by the Global Business Publications.
                                    </p>
                                </div>

                                <Row className="mb-4">
                                    <Col md={6}>
                                        <Card className="h-100 border-primary">
                                            <Card.Body className="text-center">
                                                <i className="bi bi-currency-euro text-primary mb-3" style={{ fontSize: '3rem' }}></i>
                                                <h4 className="text-primary mb-3">Membership Fee</h4>
                                                <h2 className="display-4 text-primary mb-3">€80</h2>
                                                <p className="text-muted">Annual membership fee</p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={6}>
                                        <Card className="h-100 border-success">
                                            <Card.Body className="text-center">
                                                <i className="bi bi-calendar-check text-success mb-3" style={{ fontSize: '3rem' }}></i>
                                                <h4 className="text-success mb-3">Conference Registration</h4>
                                                <p className="mb-3">
                                                    For registering to one of our conferences you automatically become a member 
                                                    for one year from the day of registration.
                                                </p>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                                <div className="bg-light p-4 rounded mb-4">
                                    <h5 className="mb-3">
                                        <i className="bi bi-star text-warning me-2"></i>
                                        Member Benefits
                                    </h5>
                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-2">
                                            <i className="bi bi-check-circle text-success me-2"></i>
                                            Access to international network of finance professionals
                                        </li>
                                        <li className="mb-2">
                                            <i className="bi bi-check-circle text-success me-2"></i>
                                            Reduced manuscript submission fees
                                        </li>
                                        <li className="mb-2">
                                            <i className="bi bi-check-circle text-success me-2"></i>
                                            Free e-access to Multinational Finance Journal
                                        </li>
                                        <li className="mb-2">
                                            <i className="bi bi-check-circle text-success me-2"></i>
                                            Priority access to conferences and symposia
                                        </li>
                                        <li className="mb-0">
                                            <i className="bi bi-check-circle text-success me-2"></i>
                                            Quarterly journal published by Global Business Publications
                                        </li>
                                    </ul>
                                </div>

                                <div className="text-center mb-4">
                                    <h5 className="mb-3">Ready to Join MFS?</h5>
                                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                                        <Link to="/login" className="btn btn-primary btn-lg">
                                            <i className="bi bi-box-arrow-in-right me-2"></i>
                                            Login
                                        </Link>
                                        <Link to="/register" className="btn btn-outline-primary btn-lg">
                                            <i className="bi bi-person-plus me-2"></i>
                                            Register
                                        </Link>
                                    </div>
                                </div>

                                <div className="bg-primary bg-gradient text-white p-4 rounded text-center">
                                    <h6 className="mb-2">
                                        <i className="bi bi-envelope me-2"></i>
                                        Questions about Membership?
                                    </h6>
                                    <p className="mb-2">
                                        For any questions regarding the membership, please contact us at:
                                    </p>
                                    <a 
                                        href="mailto:mfs@mfsociety.org" 
                                        className="text-white fw-bold text-decoration-none"
                                    >
                                        <i className="bi bi-envelope-fill me-1"></i>
                                        mfs@mfsociety.org
                                    </a>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Membership;